import React from "react"
import { Redirect } from "react-router-dom"

import Login from "../pages/Users/Login"
import Logout from "../pages/Users/Logout"
import RecuperarPass from "../pages/Users/recoverpassword"
import ConfirmarRecuperarPass from "../pages/Users/ConfirmRecover"

import Clientes from "../pages/Customers/Index"
import AgregarCliente from "../pages/Customers/Create"
import EditarCliente from "../pages/Customers/Edit"
import ClientesImport from "../pages/Customers/Import"

import Dashboard from "../pages/dashboard/index"

import Reportes from "../pages/reportes/Index"

import Brands from "../pages/Brands/Index"
import BrandsCreate from "../pages/Brands/Create"
import BrandsEdit from "../pages/Brands/Edit"

import Categories from "../pages/Categories/Index"
import CategoriesCreate from "../pages/Categories/Create"
import CategoriesEdit from "../pages/Categories/Edit"

import Subcategories from "../pages/Subcategories/Index"
import SubcategoriesCreate from "../pages/Subcategories/Create"
import SubcategoriesEdit from "../pages/Subcategories/Edit"

import Users from "../pages/Users/Index"
import UsersCreate from "../pages/Users/Create"
import UsersEdit from "../pages/Users/Edit"

import Products from "../pages/Products/Index"
import ProductsCreate from "../pages/Products/Create"
import ProductsEdit from "../pages/Products/Edit"
import ProductsBulkOperations from "../pages/Products/BulkOperations"
import ProductView from "../pages/Products/View"
import ProductSampleImages from "../pages/ProductSampleImages/Index"
import Frames from "../pages/Frames/Index"
import Marialuisas from "../pages/Marialuisas/Index"
import Discounts from "../pages/Discounts/Index"
import PersonalizationTemplates from "../pages/PersonalizationTemplates/Index"
import HeroSlides from "../pages/HeroSlides/Index"
import Materials from "../pages/Materials/Index"

import SalesOrder from "../pages/SalesOrder/Index"
import SalesOrderCreate from "../pages/SalesOrder/Create"
import SalesOrderPrint from "../pages/SalesOrder/Print"
import SalesOrderView from "../pages/SalesOrder/View"

import Settings from "../pages/Settings/Index"

const authProtectedRoutes = [
    { path: "/dashboard", component: Dashboard, allowedRoles: ["ADMIN", "BACKOFFICE"] },

    { path: "/customers/edit/:id", component: EditarCliente, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/customers/add", component: AgregarCliente, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/customers/import", component: ClientesImport, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/customers", component: Clientes, allowedRoles: ["ADMIN", "BACKOFFICE"] },

    { path: "/brands/edit/:id", component: BrandsEdit, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/brands/add", component: BrandsCreate, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/brands", component: Brands, allowedRoles: ["ADMIN", "BACKOFFICE"] },

    { path: "/categories/edit/:id", component: CategoriesEdit, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/categories/add", component: CategoriesCreate, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/categories", component: Categories, allowedRoles: ["ADMIN", "BACKOFFICE"] },

    { path: "/subcategories/edit/:id", component: SubcategoriesEdit, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/subcategories/add", component: SubcategoriesCreate, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/subcategories", component: Subcategories, allowedRoles: ["ADMIN", "BACKOFFICE"] },

    { path: "/users/edit/:id", component: UsersEdit, allowedRoles: ["ADMIN"] },
    { path: "/users/add", component: UsersCreate, allowedRoles: ["ADMIN"] },
    { path: "/users", component: Users, allowedRoles: ["ADMIN"] },
    
    { path: "/products/view/:id", component: ProductView, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/products/edit/:id", component: ProductsEdit, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/products/add", component: ProductsCreate, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/products/bulk", component: ProductsBulkOperations, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/products/import", component: ProductsBulkOperations, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/products/update-prices", component: ProductsBulkOperations, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/products/update-products", component: ProductsBulkOperations, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/products/sample-images", component: ProductSampleImages, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/frames", component: Frames, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/marialuisas", component: Marialuisas, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/materials", component: Materials, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/personalization-mockups", component: PersonalizationTemplates, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/hero-slides", component: HeroSlides, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/products", component: Products, allowedRoles: ["ADMIN", "BACKOFFICE"] },

    { path: "/discounts", component: Discounts, allowedRoles: ["ADMIN", "BACKOFFICE"] },

    { path: "/sales-order/view/:id", component: SalesOrderView, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/sales-order/new", component: SalesOrderCreate, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/sales-order", component: SalesOrder, allowedRoles: ["ADMIN", "BACKOFFICE"] },

    { path: "/settings/users", component: () => <Redirect to="/users" />, allowedRoles: ["ADMIN"] },
    { path: "/settings/:route", component: Settings, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    { path: "/settings", component: Settings, allowedRoles: ["ADMIN", "BACKOFFICE"] },

    { path: "/reportes", component: Reportes, allowedRoles: ["ADMIN", "BACKOFFICE"] },
    
    // this route should be at the end of all other routes
    { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const publicRoutes = [
    { path: "/login", component: Login },
    { path: "/recuperar-password", component: RecuperarPass },
    { path: "/confirmar-recuperar-password/:token", component: ConfirmarRecuperarPass },
    { path: "/sales-order/print/:id", component: SalesOrderPrint },
    { path: "/ordenes/print/:id", component: SalesOrderPrint },
    { path: "/logout", component: Logout },
]

export { authProtectedRoutes, publicRoutes }
